(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-cart-upsell-prev], [data-cart-upsell-next]');
  if (!button) return;
  const upsells = button.closest('.cart-drawer__upsells');
  const list = upsells && upsells.querySelector('[data-cart-upsell-list]');
  if (!list) return;
  const direction = button.hasAttribute('data-cart-upsell-prev') ? -1 : 1;
  list.scrollBy({ left: list.clientWidth * direction, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();
})();
